export enum NotificationRoleType {    
    PendingDiscountAndRefund = 1,
    RejectFundTransaction = 2,
}
